export const load = () => ({
	title: 'Losing Church Heating Through the Windows',
	showTitle: true,
});
